import React, { FC } from 'react';
import { Switch, Route } from 'react-router-dom';

// ROUTE
import { Router } from 'constant';

// COMPONENT
import { baseLoader } from 'components/Loading';
import SomethingWentWrongPage from 'components/SomethingWentWrongPage';

const LandingPage = baseLoader(() => import('page/EInvoice/LandingPage'));

const AppEInvoiceRoute: FC = () => (
  <Switch>
    <Route exact component={SomethingWentWrongPage} path={Router.eInvoicePageSomethingWrong} />
    <Route exact component={LandingPage} path={Router.eInvoiceWithId} />
  </Switch>
);

export default AppEInvoiceRoute;
